import path from "../../../../packages/fnacdarty-svg-ref-loader/svg-id.js?id=$!./icon_i_057_arrow_left_01.svg"; export default path + "#$"